import { Bubble, Prompts } from "@ant-design/x";
import { Button, Card } from "antd";
import styled from "styled-components";

export const StyledContainer = styled(Card)`
  width: 100%;
  height: 90dvh;
  border-radius: 0.75rem;
  border: 1px solid var(--main-color);
  box-shadow: -0.25rem 0.25rem 0.25rem 0 #0000000D;
  overflow: hidden;
  position: relative;

  .ant-card-head {
    background-color: #fff;
    border: none;
    box-shadow: 0 1px 0 0 #0000001a;
    
    button {
      border: none;
      transform: scale(1.6);
    }
  }

  .ant-card-body {
    padding: 0;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    position: relative;
    height: calc(90dvh - 4.5rem);

    @media screen and (min-width: 48em) {
      height: calc(100% - 5.5rem);
    }

    &::-webkit-scrollbar {
      width: 0.25rem;
    }

    &::-webkit-scrollbar-track {
      background: rgb(234, 237, 240);
      border-radius: 0.25rem;
    }

    &::-webkit-scrollbar-thumb {
      background: var(--main-color);
      border-radius: 0.25rem;
    }
  }

  .ant-card-actions {
    display: none;
  }

  .ant-card-actions>li >span {
    cursor: default;
  }
  @media screen and (min-width: 48em) {
    width: 39.8rem;
    height: 40.625rem !important;
  }
`;

export const ContentScrollArea = styled.div`
  flex: 1 1 auto;
  padding: 1rem;
  overflow-y: auto;
  position: relative;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const SenderStickyFooter = styled.div`
  position: sticky;
  bottom: 0;
  z-index: 2;
  background-color: #fff;
  box-shadow: 0 -1px 0 0 #0000001a;
  display: flex;
  flex-direction: column;
  margin-top: 0.5rem;
  padding: 0.5rem 1rem;
  gap: 0.5rem;
`;

export const StyledBubbleList = styled(Bubble.List)`
  .ant-bubble-end,
  .ant-bubble-start {
    max-width: 85%;
    border-radius: 1rem;
    font-size: 1.125rem;
  }

  .ant-bubble-footer {
    display: none;
  }

  .ant-bubble-end {
    margin-left: auto;

    .ant-bubble-content {
      background: #FBFFC8;
      color: #0D0A0A;
    }
  }

  .ant-bubble-start {
    margin-right: auto;
  }
` as typeof Bubble.List;

export const StyledPrompts = styled(Prompts)`
  width: 100%;
  padding-block-start: 1rem;

  .ant-prompts-item {
    padding: 0.5rem;
    border-radius: 99em;
    min-width: 2.5rem;
    border: 1px solid #0076ff;

    &:hover {
      background-color:#fff !important;
    }

    .ant-prompts-content {
      align-items: center;
    }
  }
  @media screen and (min-width: 48em) {
    .ant-prompts-item {
      &:hover {
        background-color: #0076ff !important;
        .ant-prompts-label {
          color: #fff !important;
        }
      }
    }
  }
`;

export const StyledCloseButton = styled(Button)`
  .anticon {
    font-size: var(--size);
  }
`;

export const StyledName = styled.p`
  margin: 0;
  font-weight: 700;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #0d0a0a;
`;

export const StyledInfo = styled.p`
  margin: 0;
  font-size: 0.75rem;
  color: #0d0a0a;
  opacity: 0.5;
  font-weight: 400;
`;

export const StyledWrapper = styled.div`
  position: relative;
`;

export const StyledTitle = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 0.5rem;
  align-items: center;
`;

export const StyledTime = styled.time`
  font-size: 0.75rem;
  line-height: 1.25;
  color: #0d0a0a;
  opacity: 0.5;
`;

export const StyledBlock = styled.div`
  display: flex;
  align-items: center;
  padding: 1rem 0;
  gap: 0.5rem;

  .anticon {
    font-size: 3.5rem;
  }
`;

export const StyledClearTitle = styled.div`
  margin-top: 0.3rem;
  cursor: pointer;
`;

export const StyledClearWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-left: 0.6rem;

  @media screen and (min-width: 48em) {
    div:hover {
      text-decoration: underline !important;
      color: rgb(24, 19, 183) !important;
    }
  }
`;

export const VerticalDivider = styled.div`
  width: 1px;
  background:rgba(13, 10, 10, 0.2);
  margin-top: 0.2rem;
  height: 1.2rem;
`;

